// extracted by mini-css-extract-plugin
export default {"control":"II3rk","label":"zTmpV","requiredMark":"J1I9O","error":"BalzD","freeInputError":"Gvgqs"};